import DefaultHeader from '../layouts/DefaultHeader.vue'
import DefaultLayout from '../layouts/DefaultLayout.vue'
import { store } from '../stores/store.js'
import { getLabels } from '../language.js'
import useValidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import axios from 'axios'

const validIndex = (value) => value >= 0;

export default {

    name: "SharpEntry",

    components: {
        DefaultHeader,
        DefaultLayout,
    },

    data() {
        return {
            v$: useValidate(),
            lang: this.$route.query.lang,
            isSubmitting: false,
            isApprover: false,
            supervisor: '',
            selCategoryId: -1,
            selBranchName: '',
            selBranchLocationId: -1,
            categoryDesc: '',
            desc: '',
            correctiveAction: '',
            area: '',
            equipment: '',
            dateSubmitted: new Date().toISOString().slice(0, 10),
            timeSubmitted: null,
            nearMiss: '',
            nearMissType: '',
            categories: [],
            branches: [],
            branchLocations: [],
            showForm: true,
            error: '',
            store,

            labels: {
                headerText: '',
                supervisor: '',
                branch: '',
                department: '',
                area: '',
                equipment: '',
                dateOfEvent: '',
                timeOfEvent: '',
                category: '',
                categoryDesc: '',
                desc: '',
                correctiveAction: '',
                nearMiss: '',
                nearMissType: '',
            }
        }
    },

    computed: {
        isNearMissTypeEnabled() {
            return this.nearMiss === 'Yes';
        },
    },

    validations() {
        const cannotBeFutureDate = helpers.withMessage("Date cannot be in the future",
            (value) => {
                if (!value) return true;
                const [year, month, day] = value.toString().split('-');
                const selectedDate = new Date(year, month - 1, day);
                const now = new Date();
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                return selectedDate <= today;
            });

        return {
            selCategoryId: { validIndex: helpers.withMessage("Must select an item.", validIndex) },
            selBranchName: { required },
            selBranchLocationId: { validIndex: helpers.withMessage("Must select an item.", validIndex) },
            desc: { required },
            correctiveAction: { required },
            dateSubmitted: { required, cannotBeFutureDate },
            timeSubmitted: { required },
            nearMiss: { required },
            nearMissType: { required: this.nearMiss === 'Yes' ? required : '' }
        }
    },

    mounted() {
        this.labels = getLabels(this.lang);			
        this.isApprover = store.isApprover;
        this.supervisor = store.supervisorFirstName + ' ' + store.supervisorLastName;
        this.getCategories();
        this.getAllBranches();
    },

    methods: {
        async getCategories() {
            axios.post('/sharpCategory/getByLanguage', { language: this.lang })
                .then((response) => {
                    this.categories = response.data;
                });
        },

        async getAllBranches() {
            axios.post('/sharpBranch/getAllBranches')
                .then((response) => {
                    this.branches = response.data;
                });
        },

        async getLocationsByBranch() {
            axios.post('/sharpBranch/getLocationsByBranch', { branchName: this.selBranchName })
                .then((response) => {
                    this.branchLocations = response.data;
                });
        },

        onChangeCategory() {
            var item = this.categories.find(x => x.id == this.selCategoryId);
            this.categoryDesc = item.description;
        },

        onChangeBranch() {
            this.getLocationsByBranch();
        },

        async submit(event) {
            if (this.isSubmitting) {
                return;
            }

            this.isSubmitting = true;
            event.preventDefault();
            const isValid = await this.v$.$validate();
            if (!isValid) {
                this.isSubmitting = false;
                return;
            }
            this.error = '';

            var model = {
                language: this.lang,
                employeeNumber: store.employeeNumber,
                employeeFirstName: store.firstName,
                employeeLastName: store.lastName,
                supervisorEmployeeNumber: store.supervisorEmployeeNumber,
                supervisorFirstName: store.supervisorFirstName,
                supervisorLastName: store.supervisorLastName,
                name: this.name,
                description: this.desc,
                branchName: this.selBranchName,
                dateSubmitted: this.dateSubmitted,
                dateSubmitted1: this.dateSubmitted,
                timeSubmitted: this.timeSubmitted,
                company: store.company,
                isApproved: 2,
                reasonID: this.selCategoryId,
                branchLocationid: this.selBranchLocationId,
                correctiveAction: this.correctiveAction,
                area: this.area,
                equipment: this.equipment,
                nearMiss: this.nearMiss,
                nearMissType: this.nearMissType
            }

            try {
                await axios.post('/sharpEntries/create', model);
                this.showForm = false;
            }
            catch (error) {
                this.showForm = true;
                this.error = error.response.data;
            }
            finally {
                this.isSubmitting = false;
            }

        },

        enterAnotherSHARP() {
            this.showForm = true;
            this.clearFields();
        },

        clearFields() {
            this.selCategoryId = -1;
            this.categoryDesc = '';
            this.name = '';
            this.desc = '';
            this.correctiveAction = '';
            this.area = '';
            this.equipment = '';
            this.nearMiss = '';
            this.nearMissType = '';
        }
    }
}

